import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { storage } from './firebase';

export const CLAIM_STATUSES = ['open', 'investigating', 'approved', 'rejected', 'paid'];

export const CLAIM_TRANSITIONS = {
    open: ['investigating', 'rejected'],
    investigating: ['approved', 'rejected'],
    approved: ['paid', 'rejected'],
    rejected: [],
    paid: []
};

export function normalizeClaimStatus(value) {
    const s = String(value || 'open').toLowerCase();
    if (s === 'new' || s === 'filed' || s === 'fnol') return 'open';
    if (s === 'assigned' || s === 'review') return 'investigating';
    if (s === 'closed' || s === 'settled') return 'paid';
    if (s === 'declined' || s === 'denied') return 'rejected';
    if (CLAIM_STATUSES.includes(s)) return s;
    return 'open';
}

export function claimStatusClass(status) {
    const s = normalizeClaimStatus(status);
    if (s === 'approved' || s === 'paid') return 'bd-badge bd-badge-active';
    if (s === 'rejected') return 'bd-badge bd-badge-inactive';
    return 'bd-badge bd-badge-pending';
}

export function nextClaimStatuses(status) {
    return CLAIM_TRANSITIONS[normalizeClaimStatus(status)] || [];
}

export function canStaffFileClaims(role) {
    return ['claims', 'admin', 'manager'].includes(String(role || '').toLowerCase());
}

export async function uploadClaimPhotos(tenantId, claimKey, files) {
    const list = Array.from(files || []).slice(0, 6);
    if (!list.length) return { urls: [], skipped: false };
    const urls = [];
    try {
        for (const file of list) {
            const safe = String(file.name || 'photo').replace(/[^\w.-]/g, '_');
            const path = 'claims/' + tenantId + '/' + claimKey + '/' + Date.now() + '_' + safe;
            const fileRef = ref(storage, path);
            await uploadBytes(fileRef, file, { contentType: file.type || 'image/jpeg' });
            urls.push(await getDownloadURL(fileRef));
        }
        return { urls, skipped: false };
    } catch (err) {
        return { urls: [], skipped: true, error: err.message || 'Storage not available' };
    }
}

export function fileToPhotoPayload(file) {
    return new Promise((resolve, reject) => {
        if (!file) {
            resolve(null);
            return;
        }
        if (file.size > 2.5 * 1024 * 1024) {
            reject(new Error('Photo must be under 2.5 MB'));
            return;
        }
        const reader = new FileReader();
        reader.onload = () => {
            const result = String(reader.result || '');
            const base64 = result.replace(/^data:[^;]+;base64,/, '');
            resolve({
                name: file.name || 'photo.jpg',
                contentType: file.type || 'image/jpeg',
                base64
            });
        };
        reader.onerror = () => reject(new Error('Could not read photo'));
        reader.readAsDataURL(file);
    });
}
